import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEquipment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.33997 1.33997H4.99997H18H19.66V2.99997V19V20.66H18H4.99997H3.33997V19V2.99997V1.33997ZM6.65997 2.99997H4.99997V4.65997V17.34V19H6.65997H16.34H18V17.34V4.65997V2.99997H16.34H6.65997Z",
			fill: "#616778"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.26996 7.27002H16.73V11.73H6.26996V7.27002ZM7.72996 8.73002V10.27H15.27V8.73002H7.72996Z",
			fill: "#616778"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.3161 4.21838L16.7339 4.27393L16.7261 5.73391L6.30832 5.67836L6.3161 4.21838Z",
			fill: "#616778"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.34996 19.65H6.64996V22.35H8.34996V19.65ZM12.35 19.65H10.65V22.35H12.35V19.65ZM14.65 19.65H16.35V22.35H14.65V19.65Z",
			fill: "#616778"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.24994 14.75H6.74994V16.25H8.24994V14.75ZM12.2499 14.75H10.7499V16.25H12.2499V14.75ZM14.7499 14.75H16.2499V16.25H14.7499V14.75Z",
			fill: "#616778"
		})
	]
});
export default SvgEquipment;
